/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintSpedizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintSpedizioneCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    this.domainSrvc = domainSrvc;

    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.datiAggiuntivi.indirizzoSpedizione.nazione.codice === '086') {
            self.province = responses[1];
            self.province = self.province.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.province = [{ codice: '**', descrizione: 'STATO ESTERO' }];
          }
          self.tae = responses[2];
          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];

          self.cdintDefinizioneCtrl.recuperaComuni(false, false);

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // fix CDICDDI-171 (indirizzo nazione spedizione == italia --> Forzato)
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.recuperaDomini();
      });
    };
    self.init();
  };

  CdintSpedizioneCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintSpedizioneComponent = {
    controller: CdintSpedizioneCtrl,
    controllerAs: 'cdintSpedizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintSpedizione', CdintSpedizioneComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.cmpt.js
// module id = 15
// module chunks = 0